var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultistarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62479 10.3333C6.56527 10.1026 6.44502 9.89203 6.27653 9.72355C6.10805 9.55507 5.8975 9.43481 5.66679 9.3753L1.57679 8.32063C1.50701 8.30082 1.4456 8.2588 1.40186 8.20093C1.35813 8.14306 1.33447 8.0725 1.33447 7.99996C1.33447 7.92743 1.35813 7.85687 1.40186 7.799C1.4456 7.74113 1.50701 7.6991 1.57679 7.6793L5.66679 6.62396C5.89742 6.5645 6.10792 6.44435 6.27639 6.27599C6.44486 6.10763 6.56517 5.89722 6.62479 5.66663L7.67946 1.57663C7.69906 1.50657 7.74105 1.44486 7.799 1.40089C7.85696 1.35693 7.92771 1.33313 8.00046 1.33313C8.0732 1.33313 8.14395 1.35693 8.20191 1.40089C8.25987 1.44486 8.30185 1.50657 8.32146 1.57663L9.37546 5.66663C9.43497 5.89734 9.55523 6.10789 9.72371 6.27637C9.89219 6.44486 10.1027 6.56511 10.3335 6.62463L14.4235 7.67863C14.4938 7.69803 14.5558 7.73997 14.6 7.79801C14.6442 7.85606 14.6682 7.927 14.6682 7.99996C14.6682 8.07292 14.6442 8.14387 14.6 8.20191C14.5558 8.25996 14.4938 8.3019 14.4235 8.3213L10.3335 9.3753C10.1027 9.43481 9.89219 9.55507 9.72371 9.72355C9.55523 9.89203 9.43497 10.1026 9.37546 10.3333L8.32079 14.4233C8.30118 14.4934 8.2592 14.5551 8.20124 14.599C8.14328 14.643 8.07254 14.6668 7.99979 14.6668C7.92704 14.6668 7.85629 14.643 7.79834 14.599C7.74038 14.5551 7.69839 14.4934 7.67879 14.4233L6.62479 10.3333Z",
    stroke: "#FAFBFB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2V4.66667",
    stroke: "#FAFBFB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33337H12",
    stroke: "#FAFBFB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 11.3334V12.6667",
    stroke: "#FAFBFB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "#FAFBFB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultistarIcon);
export default __webpack_public_path__ + "static/media/multistar-icon.83822c0adb153a81b1fb321375d87e60.svg";
export { ForwardRef as ReactComponent };